(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name itecAdministracio.api.persona.factory:PersonaFactory
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio.api.rol')
    .factory('RolFactory', RolFactory);

  function RolFactory(AdmConstant, DataFactory) {
    var api = AdmConstant.SERVER_PATH_ADMINISTRACIO + 'rols';
    
    var RolBase = {
        
      getAll: function(form){
        var url = api;
        return DataFactory.getWithParams(url, form);
      },
      get: function(id){
        var url = api + '/' + id;
        return DataFactory.get(url);
      },
      add: function(obj){
        return DataFactory.add(api,obj);
      },

      duplicate: function(obj){
        return DataFactory.add(api+'/duplicate',obj);
      },

      update: function(id, obj){
        var url = api + '/' + id;
        return DataFactory.update(url,obj);
      },
      delete: function(id){
        var url = api;
        return DataFactory.delete(url, id);
      },
      updateacls: function(id, obj){
        var url = api + '/' + id + '/acls';
        return DataFactory.update(url,obj);
      }

    };
    return RolBase;
  }
}());
